import type { WiwState } from '@/store';

export const getConversation = (state: WiwState) => {
  return state.workchat.conversation;
};
